import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { LogoMark } from "./LogoMark";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || "";
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sid) { navigate("/portal"); return; }
    (async () => {
      try {
        const { data } = await axios.post(`${API}/portal/auth/session`, { session_id: sid }, { withCredentials: true });
        window.history.replaceState(null, "", "/portal");
        navigate("/portal", { state: { user: data.user } });
      } catch {
        navigate("/portal", { state: { error: true } });
      }
    })();
  }, [location, navigate]);

  return (
    <div className="min-h-screen bg-ink-950 flex items-center justify-center">
      <div className="text-center">
        <LogoMark className="h-12 w-12 mx-auto mb-4 animate-pulse" color="#7FA8C9" />
        <p className="text-white/60 text-sm">Signing you in…</p>
      </div>
    </div>
  );
}
